import { Paper, Typography } from '@mui/material'
import type { ErrorComponentProps } from '@tanstack/react-router'
import { getErrorMessageWithSentry } from '../../utils/sentry'
import { fonts } from '../../utils/theme/fonts.theme'
import Center from '../containers/Center'

const ErrorComponent = ({ error }: ErrorComponentProps) => (
  <Center style={{ height: '100vh', padding: '5%' }}>
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Typography style={fonts.pageTitle}>ERREUR</Typography>
      <Typography style={fonts.inputHeader}>{getErrorMessageWithSentry(error)}</Typography>
      {error instanceof Error && error.stack && (
        <Paper elevation={5} style={{ marginTop: '5%', padding: '30px', borderRadius: '10px' }}>
          <Typography style={fonts.informationSubText}>{error.stack}</Typography>
        </Paper>
      )}
    </div>
  </Center>
)

export default ErrorComponent
